export default class Reservations {
    constructor() {
        this.init();
    }
    init() {
        for (const form of document.querySelectorAll('form[data-reservation-id]')) {
            // Only get checkboxes inside this form
            const checkboxes = form.querySelectorAll('input.form-check-input[name="selectedItemsForPickup"]');

            checkboxes.forEach(checkbox => {
                checkbox.addEventListener('change', () => {
                    const releaseKey = checkbox.dataset.releaseKey;
                    const orderId = checkbox.dataset.orderId;
                    if (!releaseKey) {
                        // Toggle all checkboxes in this form with same orderId and no releaseKey
                        const group = form.querySelectorAll(
                            `input.form-check-input[name="selectedItemsForPickup"][data-order-id="${orderId}"]`
                        );
                        if (!checkbox.checked && group.length > 1) {
                            togglePartialReleaseInformation(orderId);
                        }
                        else {
                            togglePartialReleaseInformation(orderId);
                        }
                        group.forEach(cb => {
                            if (!cb.dataset.releaseKey) {
                                cb.checked = checkbox.checked;

                                if (cb.checked) {
                                    cb.setAttribute('checked', 'checked');
                                    cb.classList.remove('bg-warning');
                                } else {
                                    cb.removeAttribute('checked');
                                    cb.classList.add('bg-warning');
                                }

                            }
                        });
                    }
                });
            });
        }        
        function togglePartialReleaseInformation(orderId) {
            const infoSpan = document.getElementById(`partial-release-information-${orderId}`);
            infoSpan.classList.toggle("visually-hidden")
          
        }
    }
}

